// src/components/TokenDisplay.js
import React from 'react';
import { Calculator } from 'lucide-react';
import './TokenDisplay.css';

const TokenDisplay = ({ tokenStats, className = '' }) => {
  if (!tokenStats || (tokenStats.inputTokens === 0 && tokenStats.attachmentTokens === 0 && (tokenStats.conversationTokens || 0) === 0)) {
    return null;
  }

  return (
    <div className={`token-display ${className}`}>
      <div className="token-info">
        <div className="token-icon">
          <Calculator size={14} />
        </div>
        <div className="token-details">
          <div className="input-line">
            <span className="label">Input:</span>
            <span className="value">{(tokenStats.inputTokens + tokenStats.attachmentTokens + tokenStats.projectFilesTokens).toLocaleString()} tokens</span>
            {tokenStats.attachmentTokens > 0 && (
              <span className="attachment-indicator">
                +{tokenStats.attachmentTokens} files
              </span>
            )}
            {tokenStats.projectFilesTokens > 0 && (
              <span className="attachment-indicator">
                +{tokenStats.projectFilesTokens} project
              </span>
            )}
          </div>
          <div className="context-line">
            <span className="label">Output:</span>
            <span className="value">~{(tokenStats.estimatedOutputTokens || 0).toLocaleString()} tokens estimated</span>
          </div>
          {(tokenStats.conversationTokens || 0) > 0 && (
            <div className="context-line">
              <span className="label">Conversation:</span>
              <span className="value">{(tokenStats.conversationTokens || 0).toLocaleString()} tokens</span>
            </div>
          )}
          <div className="context-line">
            <span className="label">Total:</span>
            <span className="value">{tokenStats.totalTokens.toLocaleString()} tokens</span>
          </div>
        </div>
      </div>
      <div className="cost-info">
        <div className="cost-amount">
          ${tokenStats.nextMessageCost.toFixed(4)}
        </div>
        <div className="cost-label">
          will be charged
        </div>
      </div>
    </div>
  );
};

export default TokenDisplay;